var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNasdaqLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 44,
    viewBox: "0 0 115 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_502_71)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.1644 29.7237C79.5447 29.7237 77.2954 27.6332 77.2954 24.2637C77.2954 20.7666 79.371 18.5909 82.713 18.5909H82.9934C83.4126 18.5909 83.9898 18.6046 84.7783 18.7027V14.4816H87.1391V29.3432C87.1391 29.3432 84.896 29.7237 83.1644 29.7237ZM83.1432 20.4441C80.8563 20.4441 79.7444 21.6748 79.7444 24.205C79.7444 26.4768 81.0861 27.8889 83.2417 27.8889C83.6561 27.8889 84.1307 27.8616 84.7776 27.8064V20.5955C84.1314 20.4918 83.6103 20.4441 83.1432 20.4441ZM50.8276 29.3827L44.4505 18.2875L44.4484 29.3827H42.2258V15.3366H45.3374L51.7145 26.333L51.7118 15.3366H53.9638V29.3827H50.8276ZM71.1406 29.5989C70.0669 29.5989 68.9474 29.4789 67.6145 29.2232L67.4702 29.1959V27.2337L67.6809 27.2787C68.8564 27.5289 69.8713 27.7423 70.8869 27.7423C71.7068 27.7423 73.6169 27.6141 73.6169 26.4107C73.6169 25.4016 72.297 25.148 71.237 24.9455L71.17 24.9318C70.9717 24.895 70.785 24.8575 70.6277 24.818C69.0725 24.4157 67.4135 23.8109 67.4135 21.7334C67.4135 19.7071 69.0219 18.5459 71.8272 18.5459C73.1737 18.5459 74.151 18.6891 74.9367 18.8064L75.3183 18.8623V20.7666L75.1152 20.7298C74.2262 20.5668 73.184 20.3991 72.1821 20.3991C71.0681 20.3991 69.7462 20.6071 69.7462 21.595C69.7462 22.4152 70.828 22.6498 72.0809 22.9218C73.833 23.2996 76.005 23.7741 76.005 26.1577C76.005 28.3443 74.2337 29.5989 71.1406 29.5989ZM93.7664 29.5989C91.323 29.5989 89.06 29.1693 89.06 26.0589C89.06 22.6737 92.5594 22.6737 94.6514 22.6737C94.8593 22.6737 95.8427 22.7193 96.1443 22.7323C96.1415 20.8334 96.1176 20.3807 93.3554 20.3807C92.2606 20.3807 91.0446 20.5962 89.971 20.7884L89.7658 20.8252V18.9502L89.9039 18.9209C91.1486 18.6687 92.3488 18.5459 93.5722 18.5459C96.2489 18.5459 98.5166 18.8146 98.5166 22.1255V29.3459L98.3539 29.3643C96.4999 29.5716 95.0282 29.5989 93.7671 29.5989H93.7664ZM94.5926 24.3489C92.5751 24.3489 91.325 24.6448 91.325 26.1175C91.325 27.8221 92.9198 27.9632 94.4161 27.9632C94.9742 27.9632 95.9788 27.8916 96.2858 27.8698V24.4075C95.8536 24.3891 94.7286 24.3489 94.5926 24.3489ZM60.6418 29.5989C58.1949 29.5989 55.9327 29.1693 55.9327 26.0589C55.9327 22.6737 59.432 22.6737 61.5233 22.6737C61.7319 22.6737 62.7173 22.7193 63.0196 22.7323C63.0169 20.8334 62.9902 20.3807 60.2281 20.3807C59.1325 20.3807 57.9166 20.5962 56.8429 20.7884L56.6377 20.8252V18.9502L56.7793 18.9209C57.9852 18.6723 59.2134 18.5467 60.4448 18.5459C63.1208 18.5459 65.3892 18.8146 65.3892 22.1255V29.3459L65.2258 29.3643C63.3725 29.5716 61.9001 29.5989 60.6418 29.5989ZM61.4645 24.3489C59.4478 24.3489 58.2004 24.6448 58.2004 26.1175C58.2004 27.8221 59.7924 27.9632 61.2887 27.9632C61.8495 27.9632 62.8541 27.8916 63.1612 27.8698V24.4075C62.7255 24.3891 61.6013 24.3489 61.4652 24.3489",
    fill: "#D1D7DC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_502_71",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 17,
    width: 11,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.058 17.9091H110.335V34.2727H100.058V17.9091Z",
    fill: "#D1D7DC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_502_71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.917 34.1554V29.5477C106.996 29.6759 106.507 29.6759 106.112 29.6759C105.176 29.6759 104.137 29.4734 103.333 29.1352C101.532 28.3886 100.459 26.4932 100.459 24.0611C100.459 22.8475 100.756 20.6282 102.74 19.4323C103.737 18.8391 104.912 18.5854 106.681 18.5854C107.313 18.5854 108.168 18.6332 108.994 18.6809L110.335 18.7504V33.0877L107.917 34.1554ZM106.504 20.4393C104.105 20.4386 102.889 21.6591 102.889 24.0611C102.889 27.1539 104.703 27.8036 106.228 27.8036C106.599 27.8036 107.016 27.8036 107.94 27.6864V20.5061C107.217 20.4584 106.882 20.4393 106.504 20.4393H106.504Z",
    fill: "#D1D7DC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_502_71",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 7,
    width: 19,
    height: 23
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0968 7.01091H40.5613V29.5H22.0968V7.01091Z",
    fill: "#D1D7DC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_502_71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6792 7.01091L23.8707 28.3995C23.7742 28.6629 23.6052 28.8938 23.3832 29.0659C23.1611 29.238 22.8949 29.3442 22.6151 29.3725V29.3827H30.8695C31.5157 29.3827 32.069 28.973 32.2748 28.4002L40.086 7.01091H31.6792Z",
    fill: "#D1D7DC"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9415 29.0582C22.4202 29.0582 22.8395 28.8209 23.0959 28.4616C23.1226 28.4241 23.2163 28.2932 23.2826 28.1152L26.1467 20.2661L24.4712 15.6823C24.3736 15.4502 24.2155 15.2483 24.0133 15.0976C23.8111 14.9468 23.5722 14.8528 23.3213 14.8251C23.0704 14.7974 22.8166 14.8371 22.5863 14.9401C22.3559 15.0431 22.1574 15.2057 22.0113 15.4109C21.9839 15.4484 21.8725 15.6155 21.8246 15.7573L18.9605 23.6036L20.6435 28.2059C20.7527 28.4589 20.9338 28.6744 21.1645 28.8259C21.3952 28.9773 21.6653 29.0581 21.9415 29.0582Z",
    fill: "#D1D7DC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_502_71",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 13,
    width: 19,
    height: 24
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.31613 13.8182H22.7806V36.8616H4.31613V13.8182Z",
    fill: "#D1D7DC"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_502_71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5536 14.4891H14.2083C13.5621 14.4891 13.0088 14.8968 12.8002 15.4723L4.99179 36.8609H13.3986L21.2077 15.473C21.3091 15.1947 21.4911 14.9528 21.7308 14.7781C21.9705 14.6033 22.2569 14.5037 22.5536 14.4918V14.4891Z",
    fill: "#D1D7DC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_502_71"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 30,
    fill: "white",
    transform: "translate(5 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNasdaqLight);
export default __webpack_public_path__ + "static/media/nasdaq-light.ee2c456c43ec53a8d5189591ce883e19.svg";
export { ForwardRef as ReactComponent };